<template>
  <b-form-group id="send-out-ckeditor-wrapper" :class="type == 'email' && template_id ? 'short' : ''">
    <b-row>
      <b-col>
        <span>{{ label || trans(template_id ? ('message_template_' + type) : 'message') }}</span>
        <small id="message_template" class="ml-2 text-muted" v-if="template_id">
          <i class="fa fa-fw fa-info-circle text-muted"></i>
          <b-tooltip target="message_template" triggers="hover">
            <p v-if="type == 'email' || type == 'both'">{{ trans('message_template_email_about') }}</p>
            <p v-if="type == 'sms' || type == 'both'">{{ trans('message_template_sms_about') }}</p>
          </b-tooltip>
        </small>
        <b-dropdown
          v-if="!template_id"
          :text="trans('samples')"
          variant="link"
          class="ml-2"
          toggle-class="p-0 btn-sm"
        >
          <b-dropdown-item
            v-for="sample in sampleMessages"
            v-bind:key="sample.id"
            @click="onChooseSample(sample.id)"
          >
            {{ trans(sample.id) }}
          </b-dropdown-item>
        </b-dropdown>
        <zoom-meeting-dropdown
          :organization="organization"
          v-if="organization.has_zoom"
          @input="onZoomMeeting"
        />
      </b-col>
      <b-col class="col-auto text-right" v-if="type != 'email'">
        <div class="d-flex flex-column">
          <div :class="['text-right', messageCost > 1 ? 'text-danger' : '']">
            <em v-if="containsUnicode" v-b-tooltip.hover :title="trans('unicode_warning')">
              <small>
                <i class="fa fa-fw fa-exclamation-triangle"></i>
                {{ characterCount }}/70 ({{ messageCost }} SMS)
              </small>
            </em>
            <em v-else>
              <small>
                {{ characterCount }}/160 ({{ messageCost }} SMS)
              </small>
            </em>
          </div>
        </div>
      </b-col>
    </b-row>
    <html-textarea
      :organization="organization"
      v-model="body"
      :placeholders="placeholders"
      :disabled="disabled"
      show-insert-form-document
      hide-tips
      @ready="$emit('ready')"
    ></html-textarea>
  </b-form-group>
</template>

<script>
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import ZoomMeetingDropdown from './../zoom/ZoomMeetingDropdown'
  import sampleMessages from './SendOutMessages'

  function getSample(organization, sample_id) {
    let sample = _.find(sampleMessages, {id: sample_id})
    return sample ? `${sample.body}<p>${organization.alias}</p>` : null
  }

  export default {
    props: {
      organization: Object,
      value: String,
      label: String,
      type: String,
      template_id: Number,
      initial_message_sample_id: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      HtmlTextarea,
      ZoomMeetingDropdown,
    },
    data() {
      let body = this.value
      if (this.initial_message_sample_id) {
        body = getSample(this.organization, this.initial_message_sample_id) || body
      }
      return {
        trans: trans,
        body: body,
        sampleMessages: sampleMessages,
        getSample: getSample,
        placeholders: _.getGroupedPlaceholders(),
      }
    },
    computed: {
      bodyPlainTextLength() {
        return _.ckeditorHtmlToText(this.body).length
      },
      bodyPlainText() {
        return _.ckeditorHtmlToText(this.body)
      },
      containsUnicode() {
        return !_.isGsm7(this.body)
      },
      characterCount() {
        return this.bodyPlainText.length
      },
      segmentSize() {
        return this.containsUnicode ? 70 : 160
      },
      messageCost() {
        return Math.ceil(this.characterCount / this.segmentSize)
      },
    },
    watch: {
      value() {
        if (this.body != this.value)
          this.body = this.value
      },
      body: {
        deep: true,
        immediate: true,
        handler() {
          this.$emit('input', this.body)
        }
      },
    },
    methods: {
      onChooseSample(sample_id) {
        this.body = getSample(this.organization, sample_id) || this.body
      },
      onZoomMeeting(meeting) {
        this.body += `<a href="${meeting.join_url}">${meeting.join_url}</a>`
      },
    },
    mounted() {
      window.bodyComponent = this
    },
  }
</script>
